import React, { useEffect, useState } from 'react'
import { Row, Col, Table, Typography } from 'antd'

const ContainerDetails = (props) => {
  const containerCol = [
    {
      title: 'Container type',
      dataIndex: 'uld_type',
      key: 'uld_type',
      align: 'left',
      className: 'checklist-cols'
    },
    {
      title: 'Est. Conv Weight',
      dataIndex: 'wgt',
      key: 'wgt',
      align: 'left',
      className: 'checklist-cols',
      render: (_, record) => ( Math.round(record.wgt))
    },
    {
      title: 'Priority',
      dataIndex: 'remark',
      key: 'remark',
      align: 'left',
      className: 'checklist-cols'
    }
  ]

  const bagColumns = [
    {
      title: 'Bag Positions',
      dataIndex: 'positions',
      key: 'positions',
      align: 'left',
      className: 'checklist-cols'
    },
    {
      title: 'Bulk Bags',
      dataIndex: 'bulk',
      key: 'bulk',
      align: 'left',
      className: 'checklist-cols'
    }
  ]

  const getData = () => {
    return [
      {
        key: '1',
        positions: props.data?.bag_pos || 0,
        bulk: props.data?.bulk_bag || 0
      },
      {
        key: '2',
        positions: `${props?.data?.bag_pos_wgt || 0} lbs per pos`,
        bulk: `${props?.data?.bulk_bag_wgt || 0} lbs`
      }
    ]
  }

  const { pallet_uld = {}, pallet = {}, cargo_uld = {}, cargo = {} } = props.data?.position || {}

  // use state to keep track of excluded keys
  const [ids, setIds] = useState([])


  useEffect(() => {
    getHiglightedRows()
  }, [props.ulds])

  const getHiglightedRows = () => {
    let excludedKeys = []
    setIds([])
    props.ulds.forEach((record) => {
      for (const key of Object.keys(pallet_uld)) {
        if (
          pallet_uld[key] === record.uld_type?.substring(0, 3) &&
          Math.round(parseFloat(pallet[key])) === Math.round(parseFloat(record.wgt)) &&
          !excludedKeys.includes(key)
        ) {
          excludedKeys.push(key)
          setIds((prevIds) => [...prevIds, record.id])
          return
        }
      }
      for (const key of Object.keys(cargo_uld)) {
        if (
          cargo_uld[key] === record.uld_type?.substring(0, 3) &&
          Math.round(parseFloat(cargo[key])) === Math.round(parseFloat(record.wgt)) &&
          !excludedKeys.includes(key)
        ) {
          excludedKeys.push(key)
          setIds((prevIds) => [...prevIds, record.id])
          return
        }
      }

    })
  }


  const rowClassName = (record) => {
    return ids.includes(record.id) ? 'highlight-row' : ''
  }

  return (
    <Row className='wb-tables' gutter={[32, 0]}>
      <Col xs={24} sm={24} md={10}>
        <Typography.Text level={5} className='WnB-table-title'>Estimated Bags</Typography.Text>
        <Table
          className='WnB-table'
          columns={bagColumns}
          dataSource={getData()}
          pagination={false}
        />
      </Col>
      <Col xs={24} sm={24} md={14}>
        <Typography.Text level={5} className='WnB-table-title'>Containers in Staging</Typography.Text>
        <Table
          className='WnB-table'
          dataSource={props.ulds}
          pagination={false}
          columns={containerCol}
          rowClassName={rowClassName}
        />
      </Col>
    </Row>
  )
}

export default ContainerDetails